<template>
    <div id="verificationSuccess">
        <div class="page-content">
            <NsSpinner v-if="loading" />
            <div class="success-wrapper" v-if="emailVerified">
                <NsCard context="success">
                    <template v-slot:header>{{ txc.successTitle }}</template>
                    <template v-slot:content>
                        <div class="message">{{ txc.successMessage }}</div>
                        <div>
                            <a
                                :href="txc.successLink"
                                class="primary-hit fluid"
                            >
                                {{ txc.successButton }}
                            </a>
                        </div>
                    </template>
                </NsCard>
            </div>
            <div class="error-wrapper" v-if="!emailVerified && !loading">
                <NsCard context="danger">
                    <template v-slot:header> {{ txc.errorTitle }} </template>
                    <template v-slot:content>
                        <div class="message">{{ txc.errorMessage }}</div>
                        <div>
                            <a :href="txc.errorLink" class="primary-hit fluid">
                                {{ txc.errorButton }}
                            </a>
                        </div>
                    </template>
                </NsCard>
            </div>
        </div>
    </div>
</template>

<script>
import services from '../services/emailVerifyService';
import helper from '../helpers/emailVerifyHelper';
import { mapGetters, mapActions } from 'vuex';
import { NsCard, NsSpinner } from '@nuskin/design-components';

export default {
    name: 'verificationSuccess',
    components: { NsCard, NsSpinner },
    props: {
        showTrigger: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            emailVerified: false,
            loading: false
        };
    },
    methods: {
        ...mapActions({
            setErrorState: 'setErrorState',
            setErrorMessage: 'setErrorMessage'
        })
    },
    computed: {
        ...mapGetters({
            txc: 'translations'
        })
    },
    mounted() {
        let uuid = helper.getQueryParam('uuid');
        this.loading = true;
        services
            .validateEmail(uuid)
            .then(res => {
                this.emailVerified = res.value.success;
                this.loading = false;
            })
            .catch(e => {
                console.log('mounted e: ', e);
                this.emailVerified = false;
                this.loading = false;
            });
    }
};
</script>

<style scoped lang="scss">
#verificationSuccess {
    padding: 25px;

    .page-content {
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 600px;
        .success-wrapper {
            .message {
                margin: 0 0 24px;
            }
        }
        .error-wrapper {
            margin-left: 0;
            padding-left: 0;
            .message {
                margin: 0 0 24px;
            }
        }
    }
}
</style>
